import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Divider, Dropdown } from 'antd';
import { urlToFunction } from '@/views/account/utils/urlToFunction';
import { ReactComponent as More } from '@/views/account/assets/icons/more.svg';
import { ReactComponent as Download } from '@/views/account/assets/icons/download-fill.svg';
import { ReactComponent as Delete } from '@/views/account/assets/icons/delete.svg';
import { ReactComponent as SelectItem } from '@/views/account/assets/icons/select-item.svg';
import { ReactComponent as PreAudio } from '@/views/account/assets/icons/preAudio.svg';
import { ReactComponent as MultiSelect } from '@/views/account/assets/icons/multi-select.svg';
import { ReactComponent as View } from '@/views/account/assets/icons/view.svg';
import Utils from '@/utils';
import moment from 'moment';
import sentGAEvent from '../../../../../../../ga';
const FileItemRender = ({
  file,
  handleSelectClick,
  handleDelete,
  handleDownloadClick,
  selectGuidList,
  isEditing,
  setMediaInfo,
  handleMultipleSelect,
}) => {
  //console.log('ksdljflskdjfklsdjfklsdfjskldf', process.env.NODE_ENV);
  let ItemRef = useRef(null);
  const { t } = useTranslation(['personalCenterHistory', 'upgradePersonal']);
  const operation = () => {
    return (
      <div className='file-operation'>
        {file.media_type !== 'Image' ? (
          <div onClick={openPlayMedia} className='operation-list'>
            <View className='operation-list-icon' />{' '}
            <span>{t('upgradePersonal:View')}</span>
          </div>
        ) : (
          ''
        )}

        <div
          className='operation-list'
          onClick={(e) => {
            e.stopPropagation();
            handleDownloadClick(file);
          }}
        >
          <Download className='operation-list-icon' />{' '}
          <span>{t('upgradePersonal:Download')}</span>
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleMultipleSelect(file);
          }}
          className='operation-list'
        >
          <MultiSelect className='operation-list-icon' />
          <span>{t('upgradePersonal:MultipleSelect')}</span>
        </div>
        <Divider style={{ margin: 0 }} />
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(file);
          }}
          className='operation-list'
        >
          <Delete className='operation-list-icon' />
          <span>{t('upgradePersonal:Delete')}</span>
        </div>
      </div>
    );
  };

  const linkToEnhancer = () => {
    sentGAEvent({
      category: 'Referral',
      action: 'V2Tools_Referral',
      label: 'V2ClickEnhanceVideo',
    });
    localStorage.setItem('personalCenterFile', 'personalCenterFile');
    localStorage.setItem('otherEnhancerUrl', file.url);
    let linkUrl =
      process.env.NODE_ENV !== 'production'
        ? 'https://hitpaw-test.afirstsoft.cn/toolbox/video/enhance-video-online/editor?source=1'
        : 'https://online.hitpaw.com/toolbox/video/enhance-video-online/editor?source=1';

    window.open(linkUrl, '_blank');
  };
  const urlName = () => {
    if (file.media_job_type && urlToFunction[file.media_job_type]) {
      return urlToFunction[file.media_job_type];
    } else {
      return {
        url: 'https://online.hitpaw.com/',
        name: 'hitPaw',
      };
    }
  };

  const openPlayMedia = () => {
    setMediaInfo(file);
  };
  const nameString = (name) => {
    if (name.length < 25) {
      return name;
    } else {
      if (name) {
        if (name && name.indexOf('.') >= 0) {
          const suffixEnd = name.substr(name.lastIndexOf('.'));
          const nameStrat = name.slice(0, 25 - suffixEnd.length - 3);
          return nameStrat + '...' + suffixEnd;
        } else {
          return 'hitPaw';
        }
      } else {
        return name.slice(0, 25);
      }
    }
  };
  const imgUrl = () => {
    let res = '';
    if (file.media_type == 'Video') {
      res = (
        <div className='videoBox'>
          <img
            src={file.thumbnail_urls[0]}
            style={{ borderRadius: '10px 10px 0 0' }}
            alt='thumbnail'
          />
        </div>
      );
      // res = <img src={file.thumbnail_urls[0]} alt='thumbnail' />;
    } else if (file.media_type == 'Image') {
      res = <img src={file.url} alt='thumbnail' />;
    } else {
      res = <PreAudio />;
    }
    return res;
  };
  let duration =
    (file.video_media_info && file.video_media_info.duration) ||
    (file.audio_media_info && file.audio_media_info.duration) ||
    '';
  duration = duration
    ? moment('00:00:00', 'HH:mm:ss')
        .add(parseFloat(duration), 'seconds')
        .format('HH:mm:ss')
    : '';
  return (
    <Col span={6}>
      <div className='itemContainer'>
        <div
          className='fileItem'
          ref={ItemRef}
          onClick={isEditing ? () => handleSelectClick(file) : null}
        >
          <div className='inner'>
            {imgUrl()}
            {/* hover效果 */}
            <div className='fileItem-modal'>
              <a
                href={urlName().url}
                className='urlHref'
                onClick={(e) => e.stopPropagation()}
              >
                {urlName().name}
              </a>
              {file.media_type == 'Video' &&
              file.video_media_info?.duration < 300 &&
              file.file_size / 1024 / 1024 < 100 ? (
                <div onClick={() => linkToEnhancer()} className='toEnhancer'>
                  {t('upgradePersonal:Enhance')}
                </div>
              ) : (
                ''
              )}

              <div className='fileItem-info'>
                <span>
                  {file.media_type == 'Image'
                    ? `${file.image_media_info.width}x${file.image_media_info.height}`
                    : duration}
                </span>
                {/* {file.file_size} */}
                <span>{Utils.getSize(file.file_size)}</span>
              </div>
            </div>
            {/* 选中效果 */}
            <div
              className='fileItem-select-modal'
              style={{
                display:
                  selectGuidList.some((item) => item == file.job_id) &&
                  isEditing
                    ? 'flex'
                    : 'none',
              }}
            >
              <SelectItem />
            </div>
          </div>
        </div>
        <div className='infoBox'>
          <span className='name'>{nameString(file.file_name)}</span>
        </div>
        {/* 文件功能信息 */}
        <div className='fileItem-time'>
          <span>
            {/* {file.created_at} Original file*/}
            {file.media_job_type.split('/')[1] == 'Upload' ||
            file.media_job_type.split('/')[1] == 'Uploading'
              ? t('originalFile')
              : t(Utils.getUpdateTime(file.created_at).i18Key, {
                  num: Utils.getUpdateTime(file.created_at).num,
                })}
          </span>
          <Dropdown
            overlay={operation()}
            placement='bottomRight'
            getPopupContainer={() => ItemRef.current}
            onClick={(e) => e.stopPropagation()}
          >
            <More style={{ stroke: 'black' }} />
          </Dropdown>
        </div>
      </div>
    </Col>
  );
};

export default FileItemRender;
